import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@material-ui/styles";
// component, hooks
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
import ButtonMain from "../../../../common/components/button/ButtonMain";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import featureDisplay from "../../../../common/utils/featureDisplay";
//
import Carousel0TitleImg from "../../../../../images/home_carousel_0_title/home_carousel_0_title@2x.png";
import Carousel0Img from "../../../../../images/home_carousel_0/home_carousel_0@2x.png";

// style
const StyledContainer = styled(
  Container,
  {}
)(({ theme }) => ({
  paddingTop: "64px",
  paddingBottom: "160px",
}));

const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const TopSec = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const handleGoUseFree = () => {
    navigate(handleLocaleRoute(ROUTE_PATH.LogIn));
  };

  return (
    <StyledContainer>
      <Grid container justifyContent="center" alignItems="center">
        {/* 左邊 */}
        <Grid
          item
          container
          justifyContent="flex-start"
          alignItems="center"
          sx={{ marginRight: "40px", width: "360px" }}
        >
          <Grid item>
            <Box mb={4}>
              <img
                src={Carousel0TitleImg}
                alt="home carousel title"
                width={360}
              />
            </Box>
            <Box mb={10}>
              <Typography variant="h6">
                <FormattedMessage
                  id="home.topsec.carousel0.subtitle"
                  defaultMessage="我們的服務:暢遊研究的無限可能"
                />
              </Typography>
            </Box>
            <Box>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "home.topsec.carousel0.free.use",
                    defaultMessage: "免費試用",
                  }),
                  size: "large",
                  variant: "gradient",
                  // onClick 跟 href 不能同時使用(會觸發2次navigate)
                  // onClick: handleGoUseFree,
                  href: handleLocaleRoute(ROUTE_PATH.LogIn),
                }}
              />
            </Box>
          </Grid>
        </Grid>
        {/* 右邊 */}
        <Grid
          item
          justifyContent="center"
          alignItems="center"
          sx={{ width: "720px" }}
        >
          <Box>
            <img
              src={Carousel0Img}
              alt="home carousel interaction"
              width={720}
              height={520}
            />
          </Box>
        </Grid>
      </Grid>
    </StyledContainer>
  );
};

TopSec.propTypes = {};

TopSec.defaultProps = {};

export default TopSec;
